import {createTokenManager} from 'redux-oidc';
import createTokenManagerConfig from './tokenManager.js';
import qwest from 'qwest';
import {getCSRFToken} from './csrfHelper';

export const methodTypes = {
  get: 'GET',
  delete: 'DELETE',
  post: 'POST',
  put: 'PUT',
  head: 'HEAD',
};

export default function createRequest(url, params) {
  const parsedParams = Object.assign({
    method: methodTypes.get,
    dataType: 'post',
    body: null,
    headers: {},
    cache: true,
    authorize: false,
    cors: true,
  }, params || {});

  if (parsedParams.authorize === true) {
    const manager = createTokenManager(createTokenManagerConfig());
    const token = manager['id_token'];

    parsedParams.headers['Authorization'] = token;
  }

  if([methodTypes.post, methodTypes.put, methodTypes.delete].includes(parsedParams.method) && parsedParams.authorize === true) {
    parsedParams.headers['X-XSRF-Token'] = getCSRFToken();
  }


  let execute;

  switch (parsedParams.method) {
    case methodTypes.get: {
      execute = qwest.get;
      break;
    }
    case methodTypes.post: {
      execute = qwest.post;
      break;
    }
    case methodTypes.delete: {
      execute = qwest.delete;
      break;
    }
    case methodTypes.head: {
      execute = qwest.head;
      break;
    }
    default: {
      execute = qwest.get;
      break;
    }
  }

  const options = {};

  if (Object.keys(parsedParams.headers).length > 0) {
    options.headers = parsedParams.headers;
  }
  if (parsedParams.dataType) {
    options.dataType = parsedParams.dataType;
  }
  if (!parsedParams.cors) {
    options.cache = !parsedParams.cors;
  }

  const promise = makeCancelable(execute(url, parsedParams.body, options)
    .then((xhr, response) => {
      return response;
    })
    .catch((xhr, error) => {
      // qwest passes (xhr, error) - check xhr.status for 401
      // If unauthorized (401), clear token and redirect to login
      if ((xhr && xhr.status === 401) || (error && error.status === 401)) {
        // Prevent multiple redirects
        if (isRedirecting) {
          return new Promise(() => {});
        }
        
        console.warn('401 Unauthorized detected. URL:', url);
        console.warn('Current token exists:', !!parsedParams.headers['Authorization']);
        
        isRedirecting = true;
        
        // Clear token from localStorage immediately
        try {
          localStorage.removeItem('oidc.user:' + window.idp + ':' + window.clientID);
          console.warn('Token removed from localStorage');
        } catch (e) {
          console.error('Failed to remove token:', e);
        }
        
        // Delay redirect slightly to allow console logs to be visible
        setTimeout(() => {
          window.location.href = '/login-needed';
        }, 100);
        
        // Return a never-resolving promise to prevent further code execution
        return new Promise(() => {});
      }
      throw error || xhr;
    }));

  return promise;
}

export function makeCancelable(promise) {
  let shouldResolve = true;
  const output = {
    cancel: function() {shouldResolve = false;},
    promise: function() {
      return new Promise((resolve, reject) => {
        promise.then(response => {
          if (shouldResolve) {
            resolve(response);
          } else {
            reject({canceled: true});
          }
        });
      });
    },
  };

  return output;
}

export class PromiseStore {
  constructor(...args) {
    let promises = [];

    if (args && args.length > 0 && args[0] instanceof Array) {
      promises = args[0];
    } else if (args && args.length > 0) {
      promises = args;
    }

    this.promises = promises;
  }

  add(p) {
    this.promises.push(p);
    return p;
  }

  cleanUp() {
    for (const p of this.promises) {
      if (p && p.cancel && typeof p.cancel === 'function') {
        p.cancel();
      }
    }
  }
}

export const PromiseStoreMixin = {
  componentWillMount() {
    this.promises = new PromiseStore();
  },

  componentWillUnmount() {
    this.promises.cleanUp();
  },
};
